<script setup lang="ts"></script>

<template>
   <div class="app">
      <RouterView />
   </div>
</template>

<style src="@future-harry/nxt-styles/dist/style.css"></style>
